import React, { useState, useRef } from 'react';
import CustomInput from '../../common/InputField/InputField';
import DatePicker from '../../common/datePicker/DatePicker';
import CustomSelect from '../../common/dropdown/Dropdown';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import CustomEditor from '../customEditor/CustomEditor';
import apiService from '../../../services/apiService';
import { toast } from 'react-toastify';

const experienceOptions = [
  { value: '1_3_years', label: '1-3 years' },
  { value: '3_5_years', label: '3-5 years' },
  { value: '5_8_years', label: '5-8 years' },
  { value: '8_10_years', label: '8-10 years' },
  { value: '10_years', label: '+10 years' },
];

const Announcement = ({
  rowData,
  setIsAnnounce,
  id,
  requestDetails,
  page,
  setRowsPerPage,
  fetchRequests,
}) => {
  const [isSingleItem, setIsSingleItem] = useState(
    rowData?.filter((item) => item.status === 'approved').length
  );
  const customEditorRef = useRef();

  const selectedId = id;
  const selectedItem = rowData.find((item) => item?._id === selectedId);

  // let isSingleItem = rowData?.filter((item) => item.status === "announced").length;

  let isSingle = rowData.length === 1;

  console.log('rowDatarowData', rowData, selectedItem);

  const notify_to = [
    { value: 'everyone', label: 'Everyone' },
    {
      value: 'applicants_of_similar_profile',
      label: 'Applicants of Similar Profile',
    },
    {
      value: 'applicants_of_same_hospital',
      label: 'Applicants interested in Similar Hospital',
    },
  ];

  // Set initial values based on selected item
  const initialValues = selectedItem
    ? {
        job_title: selectedItem?.job_title || '',
        no_of_practitioners: selectedItem?.no_of_practitioners || 1,
        medical_speciality_id: selectedItem?.medical_speciality?.name || '',
        speciality_id: selectedItem?.speciality?.name || '',
        experience: selectedItem?.experience || '',
        need_category_id: selectedItem?.need_category?.name || '',
        available_at: selectedItem?.available_at?.$date?.$numberLong
          ? new Date(
              Number(selectedItem.available_at.$date.$numberLong)
            ).toISOString()
          : '',
        till: selectedItem?.till?.$date?.$numberLong
          ? new Date(Number(selectedItem?.till.$date.$numberLong)).toISOString()
          : '',

        job_description: selectedItem?.job_description || '',
        notify_to: selectedItem?.notify_to || {},
        status: selectedItem?.status || '',
      }
    : {
        job_title: '',
        no_of_practitioners: 1,
        medical_speciality_id: '',
        speciality_id: '',
        experience: '',
        need_category_id: '',
        available_at: '',
        till: '',
        job_description: '',
        notify_to: {},
        status: '',
      };

  const [count, setCount] = React.useState(
    selectedItem?.no_of_practitioners || 1
  );
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const handleCategoryReset = (setFieldValue) => {
    setFieldValue('job_description', '');
  };
  const handleNext = (setFieldValue, data, setFieldTouched) => {
    setCurrentIndex((prevIndex) => {
      let newIndex = prevIndex; // Initialize newIndex with the previous index
      let currentItem = data?.data?.job_positions?.[newIndex]; // Get the current item based on the previous index

      let announcedCount = 0; // To count the number of "announced" positions

      // Loop to find the next item with a status other than "announced" or "rejected"
      while (
        currentItem?.status === 'announced' ||
        currentItem?.status === 'rejected' ||
        currentItem?.status === 'pending'
      ) {
        setFieldTouched('job_description', false);
        setFieldTouched('job_title', false);
        setFieldTouched('notify_to', false);
        announcedCount += currentItem?.status === 'announce' ? 1 : 0; // Count announced items
        newIndex = (newIndex + 1) % rowData.length; // Move to the next item
        currentItem = data?.data?.job_positions?.[newIndex]; // Update currentItem to the next one

        // If we looped through all items, stop
        if (newIndex === prevIndex) {
          setIsAnnounce(false);

          break;
        }
      }

      // If we have only one "announced" job left, change the status to "Announce" and close the modal
      if (announcedCount === 1 && currentItem?.status === 'announced') {
        // setFieldValue("status", "Announce");
        setIsAnnounce(false); // Close the modal here if needed
        // You can also add any logic for closing the modal based on your implementation.
      } else {
        // If the current item is valid (not announced or rejected), update the field values
        if (currentItem?.status !== 'announced') {
          setFieldValue('job_title', currentItem?.job_title || '');
          setFieldValue(
            'no_of_practitioners',
            currentItem?.no_of_practitioners || 1
          );
          setCount(currentItem?.no_of_practitioners);
          setFieldValue(
            'medical_speciality_id',
            currentItem?.medical_speciality?.name || ''
          );
          setFieldValue('speciality_id', currentItem?.speciality?.name || '');
          setFieldValue('experience', currentItem?.experience || '');
          setFieldValue(
            'need_category_id',
            currentItem?.need_category?.name || ''
          );
          setFieldValue(
            'available_at',

            currentItem?.available_at?.$date?.$numberLong
              ? new Date(
                  Number(currentItem?.available_at.$date.$numberLong)
                ).toISOString()
              : '' || ''
          );
          setFieldValue(
            'till',
            currentItem?.till?.$date?.$numberLong
              ? new Date(
                  Number(currentItem?.till.$date.$numberLong)
                ).toISOString()
              : '' || ''
          );
          setFieldValue('status', currentItem?.status || '');
          setFieldValue('job_description', '');
          setFieldValue('job_position_id', currentItem?._id || '');
          setFieldValue('notify_to', {});
          // handleCategoryReset(setFieldValue)
        }
      }

      return newIndex; // Return the updated index
    });
  };

  const validationSchema = Yup.object({
    job_title: Yup.string().required('Job Title is required'),
    speciality_id: Yup.string().required('Speciality is required'),
    notify_to: Yup.object()
      .nullable()
      .required('Notify To is required')
      .test(
        'is-not-empty',
        'Notify To is required',
        (value) => value && Object.keys(value).length > 0
      ),
    no_of_practitioners: Yup.number()
      .min(1, 'Must be at least 1')
      .required('Number of Practitioners is required'),
    medical_speciality_id: Yup.string().required(
      'Practitioner Level is required'
    ),
    experience: Yup.string().required('Experience Level is required'),
    need_category_id: Yup.string().required('Category is required'),
    available_at: Yup.mixed().required('Start Date is required'),
    till: Yup.mixed().required('End Date is required'),
    job_description: Yup.string().required('Job Description is required'),
  });

  const handleSubmit = async (values, { setFieldValue, setFieldTouched }) => {
    if (selectedItem.status === 'announced') {
      toast.error('Status is already Announced!', { toastId: 'Announced' });
      return;
    }

    const tillTimestamp = values?.till?.$date?.$numberLong;
    const availTimestamp = values?.available_at?.$date?.$numberLong;

    const formatDate = (timestamp) => {
      if (!timestamp) return null;
      const dateObj = new Date(Number(timestamp));
      return `${dateObj.getDate()}-${dateObj.getMonth() + 1}-${dateObj.getFullYear()}`;
    };

    const till = tillTimestamp ? formatDate(tillTimestamp) : values?.till;
    const avail = availTimestamp
      ? formatDate(availTimestamp)
      : values?.available_at;

    console.log({ till, avail });

    console.log({ avail }); // Outputs: Valid Date Object

    const payload = {
      ...values,
      available_at: avail,
      till: till,
      notify_to: values.notify_to.value,
      medical_speciality_id: selectedItem?.medical_speciality?._id || '',
      speciality_id: selectedItem?.speciality?._id || '',
      need_category_id: selectedItem?.need_category?._id || '',
      job_position_id: values?.job_position_id || selectedItem?._id || '',
    };

    try {
      const response = await apiService.post(`announced-jobs/create`, payload);

      const requestDetailResponse = await apiService.get(
        `job-requests/${requestDetails?._id}`
      );
      const announcedItemsCount =
        requestDetailResponse?.data?.job_positions?.filter(
          (item) => item.status === 'approved'
        ).length;
      setIsSingleItem(announcedItemsCount);
      fetchRequests();
      toast.success(`${response.message}`, { toastId: 'error-announced-job' });
      handleNext(setFieldValue, requestDetailResponse, setFieldTouched);
    } catch (error) {
      toast.error(`${error}`, { toastId: 'error-announced-job2' });
    }
  };

  const getLabelByValue = (value) => {
    const option = experienceOptions.find((opt) => opt.value === value);
    return option ? option.label : null; // Return label if found, otherwise return null
  };

  return (
    <div className="fixed  inset-0  flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full h-[95vh] max-w-3xl p-6 overflow-auto rounded-lg shadow-lg">
        <div className="flex justify-between items-center mb-6 border-b pb-4">
          <div>
            <h2 className="text-lg font-semibold">Draft Announcement</h2>
          </div>
          <button
            className="text-gray-500 hover:text-red-500"
            onClick={() => setIsAnnounce(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, setFieldValue, handleChange }) => (
            <Form>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Job Title
                  </label>
                  <CustomInput
                    name="job_title"
                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                    value={values.job_title}
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.job_title && errors.job_title && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.job_title}
                    </div>
                  )}
                </div>

                <div className="w-full max-w-sm">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    No of Practitioners
                  </label>
                  <div className="h-[44px] flex items-center border rounded-[12px]">
                    {/* Decrement Button */}
                    <button
                      type="button"
                      className="w-10 h-[40px]  flex justify-center items-center bg-[#f2f2f2] "
                    >
                      -
                    </button>

                    {/* Input Field */}
                    <input
                      disabled={true}
                      name="no_of_practitioners"
                      value={count}
                      className="w-full text-center focus:outline-none border-0 bg-[#f2f2f2]"
                      readOnly
                    />

                    {/* Increment Button */}
                    <button
                      type="button"
                      className="w-9 h-[40px]  flex justify-center items-center bg-[#f2f2f2] text-lg"
                    >
                      +
                    </button>
                  </div>
                  {touched.noOfPractitioners && errors.noOfPractitioners && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.noOfPractitioners}
                    </div>
                  )}
                </div>

                {/* Add similar structure for other fields, e.g., Practitioner Level, Experience Level, etc. */}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Medical Speciality
                  </label>
                  <CustomSelect
                    disabled={true}
                    value={values.medical_speciality_id}
                    name="medical_speciality_id"
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.medical_speciality_id &&
                    errors.medical_speciality_id && (
                      <div className="text-red-500 text-sm mt-1">
                        {errors.medical_speciality_id}
                      </div>
                    )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {' '}
                    Speciality
                  </label>
                  <CustomSelect
                    disabled={true}
                    value={values?.speciality_id}
                    name="speciality_id"
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.speciality_id && errors.speciality_id && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.speciality_id}
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Experience Level
                  </label>
                  <CustomSelect
                    disabled={true}
                    value={getLabelByValue(values.experience)}
                    name="experience"
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.experience && errors.experience && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.experience}
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Category
                  </label>
                  <CustomSelect
                    disabled={true}
                    name="need_category_id"
                    value={values.need_category_id}
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.need_category_id && errors.need_category_id && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.need_category_id}
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Start Date
                  </label>
                  <DatePicker
                    className="bg-[#f2f2f2]"
                    disabled={true}
                    name="available_at"
                    value={values.available_at}
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.available_at && errors.available_at && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.available_at}
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    End Date
                  </label>
                  <DatePicker
                    disabled={true}
                    className="bg-[#f2f2f2]"
                    value={values.till}
                    name="endDate"
                    onChange={(e) => handleChange(e)}
                  />
                  {touched.till && errors.till && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.till}
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Notify To
                  </label>
                  <CustomSelect
                    zIndex={'99999'}
                    name="notify_to"
                    options={notify_to}
                    value={values.notify_to.label}
                    onFieldSelect={(e) => setFieldValue('notify_to', e)}
                  />
                  {touched.notify_to && errors.notify_to && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.notify_to}
                    </div>
                  )}
                </div>
              </div>

              <CustomEditor
                ref={customEditorRef}
                name="job_description"
                value={values.job_description}
                setValue={(e) => {
                  setFieldValue('job_description', e); // Get the value from the event and update Formik state
                }}
              />
              {touched.job_description && errors.job_description && (
                <div className="text-red-500 text-sm mt-1">
                  {errors.job_description}
                </div>
              )}
              <div className="flex justify-between mt-6 gap-4">
                <button
                  type="button"
                  className="w-full px-4 py-2 bg-[white] text-[#000929] border text-gray-700 rounded-lg"
                  onClick={() => setIsAnnounce(false)}
                >
                  Cancel
                </button>
                {isSingleItem <= 1 || isSingle ? (
                  <button
                    type="submit"
                    className="w-full px-4 py-2 bg-[#008556] text-white rounded-lg"
                  >
                    Announce
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="w-full px-4 py-2 bg-[#008556] text-white rounded-lg"
                  >
                    Announce and Move to Next
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Announcement;

// <button type="button" className="w-full px-4 py-2 bg-[white] text-[#008556] rounded-lg border border-[#008556]">Add Next</button>
